import { Navigate, Outlet } from 'react-router-dom';

import PasswordRequirementGate from '../components/PasswordRequirementGate';

export interface RoutesI {
	token: string;
}

// Toda ruta privada pasa por el gate: así se pregunta si hay que establecer contraseña en
// cualquier carga con sesión, también al recargar con la sesión ya abierta.
const PrivateRoute = ({ token }: RoutesI) => {
	return token ? (
		<PasswordRequirementGate token={token}>
			<Outlet />
		</PasswordRequirementGate>
	) : (
		<Navigate to={`/${window.location.search}`} />
	);
};

export default PrivateRoute;
